// src/components/Sucursales/FormularioSucursal.styles.ts

import styled, { keyframes } from 'styled-components';

// Contenedores y Layout
export const FormWrapper = styled.div`
  width: 100%;
  padding: 1.5rem;
  background-color: #ffffff;
`;

export const FormContainer = styled.form`
  width: 100%;
  max-width: 64rem;
  margin: auto;
  padding: 2rem;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
`;

export const Header = styled.header`
  margin-bottom: 2rem;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
`;

export const Subtitle = styled.p`
  margin-top: 0.25rem;
  color: #6b7280;
`;

export const SectionsContainer = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FormSection = styled.section`
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 1.5rem;
  transition: all 0.3s ease-in-out;
`;

export const Legend = styled.legend`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  user-select: none;
  gap: 0.75rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #1d4ed8;
  padding: 0 0.5rem;
  margin: 0;
`;

export const ChevronWrapper = styled.div<{ $isOpen: boolean }>`
  display: inline-flex;
  transition: transform 0.3s ease-in-out;
  transform: rotate(${props => (props.$isOpen ? '180deg' : '0deg')});
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem 1.5rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

// Campos de Input
export const InputGroup = styled.div`
  position: relative;
  width: 100%;
`;

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
`;

export const InputIconWrapper = styled.div`
  position: relative;
`;

export const InputIcon = styled.span`
  position: absolute;
  top: 50%;
  left: 0.875rem;
  transform: translateY(-50%);
  pointer-events: none;
  color: #9ca3af;
  display: flex;
  align-items: center;
`;

export const InputField = styled.input`
  width: 100%;
  padding: 0.65rem 1rem 0.65rem 3rem;
  color: #111827;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  outline: none;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: #9ca3af;
  }

  &:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);
  }
`;

export const ErrorText = styled.p`
  margin-top: 0.375rem;
  font-size: 0.75rem;
  color: #dc2626;
`;

// Switch (Checkbox estilizado)
export const SwitchGroupContainer = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

export const SwitchGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const SwitchToggle = styled.label`
  position: relative;
  display: inline-flex;
  height: 1.75rem;
  width: 3.5rem;
  flex-shrink: 0;
  cursor: pointer;
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const SwitchSlider = styled.span<{ checked: boolean; color?: string }>`
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: ${props => (props.checked ? (props.color || '#2563eb') : '#e5e7eb')};
  border-radius: 9999px;
  transition: background-color 0.2s ease-in-out;

  &::before {
    content: "";
    position: absolute;
    height: 1.25rem;
    width: 1.25rem;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.2s ease-in-out;
    transform: ${props => (props.checked ? 'translateX(1.75rem)' : 'translateX(0)')};
  }

  ${HiddenCheckbox}:focus-visible + & {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #60a5fa;
  }
`;

export const SwitchLabel = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
`;

// Botón
export const ButtonWrapper = styled.div`
  margin-top: 2.5rem;
  display: flex;
  justify-content: flex-end;
`;

export const SubmitButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.75rem 1.75rem;
  background-color: #1d4ed8;
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #1e40af;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  }
`;

// En FormularioSucursal.styles.ts

// ... tus otros estilos ...

// Estilos para el mensaje de éxito o error
export const SubmitMessage = styled.div<{ status: 'success' | 'error' }>`
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background-color: ${({ status }) => status === 'success' ? '#E6F9F0' : '#FDEDED'};
  color: ${({ status }) => status === 'success' ? '#00875A' : '#F75A68'};
`;

// Animación para el spinner del botón
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.span`
  display: inline-block;
  animation: ${rotate} 1s linear infinite;
`;
